"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgTrello(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      transform: "translate(4 4)",
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("rect", {
        width: 24,
        height: 24,
        fill: "#0079BF",
        rx: 3
      }), (0, _jsxRuntime.jsx)("rect", {
        width: 7.2,
        height: 10.8,
        x: 13.8,
        y: 3,
        fill: "#FFF",
        rx: 1.44
      }), (0, _jsxRuntime.jsx)("rect", {
        width: 7.2,
        height: 16.8,
        x: 3,
        y: 3,
        fill: "#FFF",
        rx: 1.44
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Trello.js.map